import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PreventDragdropModule } from '../drag-and-drop/prevent-dragdrop.module';
import { IconModule } from '../icon/icon.module';
import { AvatarComponent } from './avatar.component';

@NgModule({
  imports: [CommonModule, IconModule, PreventDragdropModule],
  declarations: [AvatarComponent],
  exports: [AvatarComponent],
})
export class AvatarModule {}

export { AvatarComponent } from './avatar.component';
